import React, { useEffect, useState, useRef } from 'react';
import BlogCard from './BlogCard';
import ApiService from '../../api/ApiService';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Splide, SplideSlide } from "@splidejs/react-splide";


const BlogSlider = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const ref = useRef();
    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await ApiService.fetchBlogs();
                setBlogs(res);
            } catch (error) {
                console.error("Error fetching blogs:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBlogs();
    }, []);

    const skeletons = Array.from({ length: 3 }, (_, i) => (
        <div className="p-3" key={i}>
            <div className="shadow rounded-3 overflow-hidden bg-light" style={{ height: 400 }} />
        </div>
    ));

    return (
  <section className="upcoming-immersions">
      <div className="container">
        <div className="heading">
          <h2 className="head-1">LATEST BLOG</h2>
        </div>
        <div className="row" aria-label="Blog carousel section">
            {loading ? (
                <div className="d-flex justify-content-between w-100">{skeletons}</div>
            ) : (
                <>
                    <Splide
                        className="testimonial-slider"
                        ref={ref}
                        options={{
                            perPage: 3,
                            perMove: 1,
                            gap: 20,
                            arrows: false,
                            pagination: true,
                            autoplay: false,
                            speed: 1000,
                            interval: 8000,
                            breakpoints: {
                                576: { perPage: 1, gap: 1 },
                                768: { perPage: 2, trimSpace: false },
                                992: { perPage: 2, gap: 1, trimSpace: false },
                                1024: { perPage: 3, gap: 1, trimSpace: false },
                                1200: { perPage: 3, trimSpace: false },
                                1400: { perPage: 3, trimSpace: false },
                            },
                        }}
                    >
                        {blogs.map((blog) => (
                            <SplideSlide key={blog._id}>
                                <div className="col-lg-12 col-md-12 col-sm-12 mb-4 h-100 w-100 py-5">
                                    <BlogCard blog={blog} />
                                </div>
                            </SplideSlide>
                        ))}
                    </Splide>
                    <div className="arrow-wrap">
                        <button className="slider-btn prev box-hover" onClick={() => ref.current.splide.go("-1")}> <FiChevronLeft /> </button>
                        <button className="slider-btn next box-hover" onClick={() => ref.current.splide.go("+1")}> <FiChevronRight /> </button>
                    </div>
                </>
            )}
        </div>
        </div>
        </section>
    )
}

export default BlogSlider
